module.exports = __webpack_public_path__ + "static/img/snow_ticket.d9657e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/winterOlympics/dialog/snow_ticket.png
// module id = H8uZ
// module chunks = 33